import React from 'react';
import './Testimonials.css';
import avatar1 from '../assets/home/avatars/1.jpg';
import avatar2 from '../assets/home/avatars/2.jpg';
import avatar3 from '../assets/home/avatars/3.jpg';

const Testimonials = () => {
  const testimonials = [
    {
      rating: 5,
      text: "Just held the most fantastic baby shower at Drakes! I was able to reserve the whole upstairs area for our event, and it was the perfect space with room for both decorations and for guests to mingle. It was so easy and wonderful to work with owner Christian, who went above and beyond to accommodate all our needs. There was great communication with quick response times. I was allowed to go in well ahead of time to set up and decorate. Both Christian and every single one of the staff were all so friendly, and the food was also amazing as well! Everybody had a great time. I would absolutely host another party here.",
      author: "Love B.",
      avatar: avatar1
    },
    {
      rating: 4,
      text: "Came here for breakfast on NYE. The food was pretty good. Had the BPR combo. The best part was the eggs - cooked PERFECTLY, and the tater tots were crispy and not too oily. The waffle was huge, soft and buttery. My only complaint was that we passed on getting coffee from a place down the street because we didn't want to be the people who bring outside food/drinks, only to be told the espresso machine was not working. Only thing available was drip coffee, which tasted sour/burned. Overall, cute place and decorations were cute for the holiday.",
      author: "Ada M.",
      avatar: avatar2
    },
    {
      rating: 5,
      text: "What a cool ambiance here! The brick walls, high ceilings, crystal chandeliers, center bar, and homestyle tables throughout gives this place such a unique and fun atmosphere that is very enjoyable! We tried the Earl Grey martini, Lavender Iced coffee, Strawberry lemonade, Chilaquiles, and Country fried chicken steak with gravy. All were delicious! The chilaquiles were truly enjoyable, and the flavors were on point. They brought out the food fairly fast, and it was hot and fresh. They have alot of fun drinks on the menu, a variety of dishes (can't wait to try loco moco next!) The only feedback we had was to add more gravy to the dish, other than that, all was superb and we will definitely be back to also try the dinner menu!",
      author: "Miriam T.",
      avatar: avatar3
    },
  ];

  const renderStars = (rating) => {
    return "★".repeat(rating);
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h2>What our customers<br />are saying</h2>
        <p className="testimonials-subtitle">Check out our most recent reviews!</p>
        
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">{renderStars(testimonial.rating)}</div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="author">
                <img 
                  src={testimonial.avatar} 
                  alt={`${testimonial.author} avatar`} 
                  className="author-avatar"
                />
                <span className="author-name">{testimonial.author}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 